import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SalesService } from 'app/services/sales.service';
import { NewUserListViewModel } from './new-user-list.viewmodel';
import { DropDown, DropDownItem } from 'app/components';
import { AgGridNg2 } from 'ag-grid-angular';
import { ColumnApi, GridApi, RowDoubleClickedEvent } from 'ag-grid';
import { Subject, Subscription } from 'rxjs';
import { UserInfoModalComponent } from './modal/user-info-modal';
import { AlertService } from 'app/services';
import { AgDropdownEditor } from 'app/components/ag-grid/editor/ag-dropdown.editor';


declare var $:any;

@Component({
  selector: 'new-user-list',
  templateUrl: 'new-user-list.html',
  // styleUrls: ['tx-ui-inner-3.css'],
  // encapsulation: ViewEncapsulation.None

})
export class NewUserList implements OnInit, AfterViewInit, OnDestroy {

  // $.sweetModal.confirm("매핑된 선사를 변경하시겠습니까?", function() {
  //   that.fwdrService.postFwdrLineList(reqBody, resp => {
  //       that.alertService.success('선사 변경이 완료되었습니다.');
  //       fwdr.line = _.find(that.oceanLineList, {lineCd : fwdr.lineCd});
  //       fwdr.selectedLine = null;
  //       if(!_.isEmpty(this.reqList)) {
  //         let findFwdrIndex = _.findIndex(this.reqList, {entrpsNm : fwdr.entrpsNm});
  //         if(findFwdrIndex > -1) {
  //           this.reqList.splice(findFwdrIndex, 1);
  //         }
  //       }
  //     },
  //     err => {
  //       that.alertService.error('에러가 발생했습니다. 다시 시도해주세요.');
  //     },
  //     () => {

  //     }
  //   );
  // });


  private viewModel: NewUserListViewModel;


  @ViewChild('dropdownJob') dropdownJob: DropDown<string>;
  @ViewChild('dropdownSalesManager') dropdownSalesManager: DropDown<number>;
  @ViewChild('dropdownUserStatus') dropdownUserStatus: DropDown<number>;
  @ViewChild('dropdownLingoAuth') dropdownLingoAuth: DropDown<number>;
  
  @ViewChild('gridUsers') gridUsers: AgGridNg2;

  @ViewChild('userInfoModal') userInfoModal: UserInfoModalComponent;
  
  private getUsersSubject = new Subject();
  private getUsersSubscription: Subscription;


  constructor(private salesService: SalesService, private alertService: AlertService) {
    this.viewModel = new NewUserListViewModel(this.salesService, this.alertService);
  }
  
  ngOnInit(): void {
    this.getUsersSubscription = this.getUsersSubject.debounceTime(300).subscribe(e => this.getUsers());
  }

  ngAfterViewInit() {
  }

  ngOnDestroy(): void {
    this.getUsersSubscription.unsubscribe();
    this.viewModel.destroy();
  }


  onBodyClick(event?: UIEvent): void {

    if (event && event.target) {
      if (event.target['parentElement'] != this.dropdownJob.elementRef.nativeElement) {
        this.dropdownJob.close();
      }

      if (event.target['parentElement'] != this.dropdownSalesManager.elementRef.nativeElement) {
        this.dropdownSalesManager.close();
      }

      if (event.target['parentElement'] != this.dropdownUserStatus.elementRef.nativeElement) {
        this.dropdownUserStatus.close();
      }

      if (event.target['parentElement'] != this.dropdownLingoAuth.elementRef.nativeElement) {
        this.dropdownLingoAuth.close();
      }

    }
  }


  
  
  moveFirstPage() {
    this.viewModel.pageNo = 1;
    this.getUsersSubject.next();
  }
  moveBeforePage() {
    if (this.viewModel.pageNo - 1 <= 0) {
      this.viewModel.pageNo = 1;
    } else {
      this.viewModel.pageNo = this.viewModel.pageNo - 1;
    }
    this.getUsersSubject.next();
  }
  moveNextPage() {
    if (this.viewModel.pageNo + 1 > this.viewModel.pageCount) {
      this.viewModel.pageNo = this.viewModel.pageCount
    } else {
      this.viewModel.pageNo = this.viewModel.pageNo + 1;
    }
    this.getUsersSubject.next();
  }
  moveLastPage() {
    this.viewModel.pageNo = this.viewModel.pageCount;
    this.getUsersSubject.next();
  }
  movePage(pageNo) {
    this.viewModel.pageNo = pageNo;
    this.getUsersSubject.next();
  }

  inputTextKeydown(event: KeyboardEvent) {
    if (event.key && event.key === 'Enter') {
      this.getUsers();
    }
    
  }


  getUsers() {
    this.viewModel.gridViewModel.showLoadingOverlay();
    
    this.viewModel.getUsers(() => {
      this.viewModel.gridViewModel.hideOverlay();
    });
  }


  onGridUsersReady(event) {
    if (this.viewModel && this.viewModel.gridViewModel) {
      this.viewModel.gridViewModel.onGridUsersReady(event);
    }
  }

  
  onGirdUserRowDoubleClicked(event: RowDoubleClickedEvent) {
    this.viewModel.openUserInfoModal(event.data);
  }


  saveUserInfo() {
    this.viewModel.patchUserInfo();
  }


  frameworkComps = {
    dropdownEditor: AgDropdownEditor
  };


}



// WEBPACK FOOTER //
// ./src/app/containers/user/new-user-list.ts